var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toasts'),_vm._v(" "),_c('div',{staticClass:"public-view__table"},[_c('Table',{attrs:{"database":_vm.database,"table":_vm.table,"fields":_vm.fields,"view":_vm.view,"read-only":true,"table-loading":false,"store-prefix":'page/'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }